import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { EntityType, GlossaryTermAssociation } from '../../../../types.generated';
import { HoverEntityTooltip } from '../../../recommendations/renderer/component/HoverEntityTooltip';
import { useEntityRegistry } from '../../../useEntityRegistry';
import TermContent from './TermContent';

const TermLink = styled(Link)`
    display: inline-block;
    max-width: 235px;
    margin-right: 5px;

    .label-tag {
        width: 100%;
    }
`;

interface Props {
    term: GlossaryTermAssociation;
    entityUrn?: string;
    entitySubresource?: string;
    canRemove?: boolean;
    readOnly?: boolean;
    highlightText?: string;
    fontSize?: number;
    onOpenModal?: () => void;
    refetch?: () => any;
}

export default function StyledTerm(props: Props) {
    const { term } = props;
    const entityRegistry = useEntityRegistry();

    return (
        <HoverEntityTooltip entity={term.term}>
            <TermLink to={entityRegistry.getEntityUrl(EntityType.GlossaryTerm, term.term.urn)} key={term.term.urn}>
                <TermContent {...props} />
            </TermLink>
        </HoverEntityTooltip>
    );
}
